export default __webpack_public_path__ + "static/media/Pennsylvania.c55bb731.jpg";